module.exports = __webpack_public_path__ + "img/down.ba46c001.svg";